import { NgModule } from "@angular/core";
import { EqualHeightDirective } from "./equal-height/equal-height";
import { WatchSizeRotateDirective } from "./watch-size-rotate/watch-size-rotate";
import { IosWebTouchDetectDirective } from "./ios-touch-detect/ios-touch-detect.directive";
import { FlipOnClickDirective } from "./flip-on-click/flip-on-click.directive";
import { CDNImageDirective } from "./cdn-image/cdn-image.directive";

@NgModule({
  declarations:[
  CDNImageDirective,
  EqualHeightDirective,
  WatchSizeRotateDirective,
  IosWebTouchDetectDirective,
  FlipOnClickDirective,
],
exports:[
  CDNImageDirective,
  EqualHeightDirective,
  WatchSizeRotateDirective,
  IosWebTouchDetectDirective,
  FlipOnClickDirective,
]
})
export class directivesModule { }
